import { render, staticRenderFns } from "./ViewAsRoleBanner.vue?vue&type=template&id=ed7a957e"
import script from "./ViewAsRoleBanner.vue?vue&type=script&lang=js"
export * from "./ViewAsRoleBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports